export const skills = [
        {
            img: "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_640.png",
            p: 'HTML'
        },
        {
            img: "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_1280.png",
            p: 'CSS'
        },
        {
            img: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
            p: 'JavaScript'
        },
        {
            img: "https://sujanbyanjankar.com.np/wp-content/uploads/2019/01/React.js_logo-512.png",
            p: 'React.js'
        },
        {
            img: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/nodejs/nodejs.png",
            p: 'Node.js'
        }, 
        {
            img: "https://d2eip9sf3oo6c2.cloudfront.net/tags/images/000/000/359/full/expressjslogo.png",
            p: 'Express.js'
        },
        {
            img: "https://classes.engineering.wustl.edu/cse231/core/images/2/26/Java.png",
            p: 'Java'
        }, 
        {
            img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/2048px-Python-logo-notext.svg.png",
            p: 'Python'
        }
    ]